import MobileDetect from 'mobile-detect';
import { useMemo } from 'react';
import { useWindowSize } from 'usehooks-ts';

export const breakpoints = {
  small: { min: 400, max: 1580, threshold: -20 },
  medium: { min: 1581, max: 3799, threshold: 0 },
  large: { min: 3800, max: Infinity, threshold: 100 },
} as const satisfies Record<
  string,
  { min: number; max: number; threshold: number }
>;

export type BreakpointName = keyof typeof breakpoints;

export function useDevice() {
  const { width, height } = useWindowSize();
  const detect = new MobileDetect(window.navigator.userAgent);
  const isMobile = detect.mobile() || width < 500;

  const currentBreakpoint = useMemo(() => {
    const entry = Object.entries(breakpoints).find(
      ([_, value]) => width >= value.min && width <= value.max,
    );
    return entry
      ? { name: entry[0] as BreakpointName, ...entry[1] }
      : { name: 'medium' as BreakpointName, ...breakpoints.medium };
  }, [width]);

  return {
    width,
    height,
    isMobile,
    breakpoint: currentBreakpoint,
    threshold: currentBreakpoint.threshold,
  };
}
